import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 300px;
    height: 100px;
  }

  span.divider {
    display: inline-block;
    width: 3px;
    height: 75px;
    background-color: #333333;
  }

  button {
    margin-top: 50px;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  h1 {
    margin: 0;
  }
`
